import { SettingsHeading } from "../../components/settings/SettingsHeading";
import type { ReactNode } from "react";
import { HardDrive, RefreshCw } from "lucide-react";
import { t } from "../../i18n";

export function WorkspaceStorageHeader({
  title,
  description,
  actions,
  loading,
  onRefresh,
  error,
}: {
  title: string;
  description: string;
  actions: ReactNode;
  loading: boolean;
  onRefresh: () => Promise<void>;
  error: string;
}) {
  return (
    <>
      <div className="mb-6 flex items-start justify-between gap-4">
        <SettingsHeading
          icon={HardDrive}
          title={title}
          description={description}
        />
        <div className="flex gap-2">
          {actions}
          <button
            className="button"
            disabled={loading}
            onClick={() => void onRefresh()}
          >
            <RefreshCw size={15} className={loading ? "animate-spin" : ""} />
            {t("Refresh")}
          </button>
        </div>
      </div>
      {error && (
        <div className="mb-5 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700 dark:border-red-900/50 dark:bg-red-950/20 dark:text-red-300">
          {error}
        </div>
      )}
    </>
  );
}
